var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupEnjoy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 492,
    height: 365,
    viewBox: "0 0 492 365",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.002 258.424C390.484 248.694 382.26 234.635 375.339 221.751C363.612 199.927 364.924 177.217 355.29 167.346C355.29 167.346 349.904 163.584 344.854 174.479C341.452 181.807 339.073 211.921 340.283 229.119C343.051 268.564 361.031 294.266 375.696 308.123C390.36 321.98 418.737 264.388 408 258.424",
    fill: "#188C7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.585 164.978C344.047 176.16 342.815 179.865 342.983 180.051C352.491 190.778 365.297 186.165 360.526 176.11C356.116 166.832 351.846 152.642 351.438 148.879C350.589 141.054 338.469 150.805 341.592 164.965",
    fill: "#1A395F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.22 159.669C354.055 144.164 354.22 129.116 349.863 135.187C345.505 141.259 345.292 148.349 341.73 154.756C338.168 161.162 340.971 166.25 344.691 174.478C348.411 182.706 354.213 159.669 354.213 159.669",
    fill: "#1A395F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.712 166.918C330.453 153.856 320.052 146.884 318.067 138.659C316.081 130.435 332.377 131.472 339.974 137.704C347.571 143.937 348.715 141.735 349.628 151.832C350.454 158.777 352.237 165.574 354.925 172.031L341.712 166.918Z",
    fill: "#1A395F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.274 256.455C408.546 238.551 425.595 237.199 453.419 250.577C478.04 261.899 471.388 179.994 479.704 210.628C482.997 263.062 441.443 339.484 457.413 408.74C465.846 445.318 378.111 408.249 321.006 432.715C321.006 432.715 321.672 378.11 352.279 285.547C360.383 261.043 370.334 261.276 378.277 256.46",
    fill: "#188C7C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.32 179.25C367.921 201.88 373.898 214.288 383.674 218.573C398.174 223.275 393.752 239.612 393.613 250.726C393.706 259.674 397.121 264.721 427.67 243.177C427.67 243.177 423.417 227.862 423.86 218.318C424.304 208.775 429.569 191.298 423.209 176.873C416.75 162.796 389.982 164.209 381.32 179.25Z",
    fill: "#1A395F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M415.18 190.973C415.18 190.973 432.344 194.671 419.872 206.043C407.06 217.319 424.347 225.887 424.347 225.887C424.347 225.887 430.5 198.616 434.648 183.788C441.941 159.066 386.964 139.189 376.17 161.814C369.611 175.956 379.571 182.838 379.664 182.494C386.377 169.136 392.44 172.693 399.866 174.033C421.992 177.258 415.18 190.968 415.18 190.968",
    fill: "#188C7C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M416.152 250.912C432.455 239.259 439.032 224.357 444.454 210.773C453.632 187.756 449.754 165.339 458.211 154.435C458.211 154.435 463.136 150.092 469.388 160.347C473.592 167.237 479.367 196.892 480.118 214.119C481.835 253.624 466.88 281.202 453.877 296.627C440.874 312.051 406.161 258.057 416.154 250.912",
    fill: "#188C7C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.568 150.538C470.388 161.929 472.03 165.468 471.886 165.676C463.652 177.412 450.405 174.275 454.007 163.754C457.34 154.035 459.977 139.451 459.955 135.675C459.916 127.807 473.064 136.119 471.568 150.544",
    fill: "#1A395F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M458.409 146.696C456.817 131.269 454.95 116.339 459.964 121.88C464.978 127.421 465.995 134.433 470.254 140.397C474.513 146.361 472.311 151.733 469.538 160.331C466.765 168.928 458.4 146.697 458.4 146.697",
    fill: "#1A395F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.66 152.479C481.368 138.226 490.913 130.116 491.955 121.717C492.996 113.319 476.918 116.201 470.079 123.256C463.241 130.311 461.845 128.253 462.087 138.387C462.054 145.38 461.053 152.335 459.111 159.053L471.66 152.479Z",
    fill: "#1A395F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.981 303.888C240.512 296.118 213.266 291.605 223.298 257.808C233.33 224.01 246.211 210.06 262.322 207.568C290.649 201.586 310.46 234.133 310.364 267.729C310.267 301.324 262.82 306.05 257.987 303.888",
    fill: "#1B2B41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.298 286.539C242.478 285.237 233.451 278.228 218.108 285.541C197.149 295.53 190.574 347.47 224.513 373.443C231.834 383.432 189.086 444.319 209.209 447.364C231.335 450.703 309.714 440.578 338.966 426.723C346.087 423.358 344.535 375.062 338.3 359.464C337.634 357.8 368.911 349.475 360.075 330.779C345.507 299.927 308.546 281.321 294.15 282.532C267.526 284.952 259.707 283.277 251.886 281.973L250.298 286.539Z",
    fill: "#CF2E21"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.298 286.039C256.205 271.819 254.616 256.604 247.194 253.048C234.074 246.901 241.108 232.625 248.678 233.293C261.332 234.585 248.828 217.068 266.289 215.042C283.936 212.976 297.353 227.63 294.215 244.117C291.077 260.604 283.9 256.426 286.457 267.501C287.237 271.145 288.796 278.429 292.019 281.933C295.409 285.964 287.805 292.417 275.748 292.531C265.108 292.632 250.006 286.629 250.121 286.335L250.298 286.039Z",
    fill: "#FF8200"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.057 298.528C308.024 275.219 304.447 230.936 316.427 233.601C328.406 236.267 331.643 280.799 319.671 319.169C314.066 337.134 284.115 308.062 291.057 298.528Z",
    fill: "#FF8200"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.379 301.408C337.84 279.006 359.013 247.102 369.078 250.583C379.142 254.063 351.943 298.194 351.015 322.03C350.382 338.345 324.394 310.84 328.379 301.41",
    fill: "#FF8200"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.605 269.56C300.819 254.723 297.821 240.416 302.888 245.06C307.956 249.703 309.483 256.399 313.891 261.571C318.298 266.743 316.755 272.335 314.965 281.168C313.174 290.002 303.612 269.56 303.612 269.56",
    fill: "#FF8200"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.279 278.605C345.812 263.725 347.967 249.264 351.105 255.375C354.243 261.486 353.356 268.304 355.69 274.685C358.024 281.066 354.639 285.771 349.899 293.434C345.159 301.098 343.275 278.605 343.275 278.605",
    fill: "#FF8200"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.464 189.775C163.376 196.916 154.067 216.659 156.036 229.599C158.005 242.539 118.478 190.578 118.478 190.578C118.478 190.578 138.418 169.84 151.144 152.253C163.87 134.666 169.988 113.07 196.283 126.662C222.539 140.51 239.454 152.337 226.867 165.648C214.281 178.958 209.75 178.774 193.213 183.129C176.943 187.525 171.553 182.634 167.457 189.775",
    fill: "#751C48"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.492 152.201C152.492 152.201 136.798 186.776 158.204 210.87C155.83 217.45 155.443 224.585 157.092 231.384C158.682 237.52 160.783 243.513 163.372 249.298C163.372 249.298 121.764 193.521 119.478 191.008C116.931 188.451 103.698 190.649 103.698 190.649L152.492 152.201Z",
    fill: "#E64460"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.691 143.654C169.691 143.654 156.334 129.709 150.948 138.253C145.22 147.283 149.969 152.874 150.085 157.19C150.49 169.883 150.937 183.924 163.262 194.214C175.587 204.504 189.461 199.995 205.509 178.369C221.604 156.481 200.488 118.733 169.685 143.652",
    fill: "#E64460"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.386 403.409C136.677 340.813 179.264 333.486 175.455 291.276C173.359 272.521 167.798 254.319 159.057 237.596C149.55 219.703 123.339 181.948 109.299 187.507C95.5242 193.105 77.8701 199.438 63.6243 211.403C49.11 223.333 -18.6174 409.713 4.92451 422.054C28.1961 434.356 115.386 403.409 115.386 403.409Z",
    fill: "#751C48"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.902 217.525C140.562 201.197 111.945 175.434 107.811 155.651C100.805 122.142 97.1816 89.2309 102.522 75.7072C102.522 75.7072 97.1816 94.5336 86.2315 106.99C78.8705 115.365 62.4229 127.17 59.2956 148.91C51.505 202.983 60.4931 246.138 74.5116 270.235C88.53 294.332 151.181 233.66 145.902 217.523",
    fill: "#751C48"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.8856 51.8932C83.9616 71.447 63.1891 115.114 59.5802 147.278C57.7561 163.514 100.501 114.227 100.672 113.24C100.762 112.728 99.5213 95.6945 104.281 81.0833C108.681 67.59 117.886 49.3028 121.053 45.1502C127.633 36.5028 106.317 34.7919 95.8874 51.8896",
    fill: "#E64460"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.486 51.7786C129.061 36.0836 142.637 27.9862 132.501 29.9263C122.366 31.8665 115.416 38.7564 105.762 41.7948C96.1082 44.8331 94.0782 52.5901 89.9824 64.3797C85.8867 76.1694 114.486 51.7768 114.486 51.7768",
    fill: "#E64460"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.1728 53.9588C95.3041 30.1557 91.5091 13.2568 97.3377 3.13146C103.166 -6.99388 118.509 9.54848 120.198 23.0328C121.886 36.5172 125.126 35.3939 116.438 46.3738C110.668 54.1208 105.997 62.6297 102.558 71.6585L94.1728 53.9588Z",
    fill: "#E64460"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupEnjoy);
export default __webpack_public_path__ + "static/media/GroupEnjoy.83293b95a533f6befb1b14a22e97a039.svg";
export { ForwardRef as ReactComponent };